export default [
  {
    id: 'EmEdicao',
    colunas: ['situacaoApuracao'],
    label: 'Em Edição',
    valor: 2,
  },
  {
    id: 'EmEdicaoComPendencias',
    colunas: ['situacaoApuracao'],
    label: 'Em Edição - Com Pendências',
    valor: 1,
  },
  {
    id: 'Encerrada',
    colunas: ['situacaoApuracao'],
    label: 'Encerrada',
    valor: 3,
  },
  {
    id: 'EncerradaSemMovimento',
    colunas: ['situacaoApuracao'],
    label: 'Encerrada - Sem Movimento',
    valor: 5,
  },
  {
    id: 'EncerramentoEmCurso',
    colunas: ['situacaoApuracao'],
    label: 'Encerramento Em Curso',
    valor: 4,
  },
]
